<template>
  <cos-modal
    v-model:visible="visible"
    :title="editForm.id ? t('btn.edit') : t('btn.add')"
    width="600px"
    @ok="handleSubmit"
    :confirmLoading="loading"
  >
    <a-form :model="editForm" ref="formRef" v-if="visible" autocomplete="off">
      <a-form-item
        name="arkCode"
        :label="t('operate.6rj8gj')"
        :rules="[{ required: true, message: t('common.pleaseSelect') }]"
      >
        <CusSelect appId="cos_ofbu" v-model:value="editForm.arkCode" @selectData="selectData" :disabled="editForm.id" />
      </a-form-item>
      <a-form-item
        name="amount"
        :label="t('operate.h0py67')"
        :rules="[{ required: true, message: t('common.pleaseInput') }, { validator: inputFour }]"
      >
        <a-input-number
          v-model:value="editForm.amount"
          :max="1000000000"
          :placeholder="t('common.pleaseInput')"
          v-trim
        />
      </a-form-item>
    </a-form>
  </cos-modal>
</template>
<script lang="ts">
import { ref } from 'vue'
import { addBiTurnover, updateBiTurnover } from '@/api/overseasSales/businessRuleSetting'
import type { FormInstance } from 'ant-design-vue'
import { AddBiTurnoverParams } from '@/typings/api/overseasSales'
import CusSelect from '@/components/CustomerCodeSelect/index.vue'
import { DcMessage } from '@dc-platform/dc-components'
import { useI18n } from 'vue-i18n'

export default { name: 'editModal' }
</script>
<script setup lang="ts">
const { t } = useI18n()
const visible = ref<boolean>(false)
const loading = ref<boolean>(false)
const formRef = ref<FormInstance>()
const editForm = ref<AddBiTurnoverParams>({})
const emit = defineEmits(['success'])
const toggle = (row?: AddBiTurnoverParams) => {
  visible.value = !visible.value
  if (row && row.id) {
    editForm.value = { ...row }
  } else {
    editForm.value = {}
  }
}
const inputFour = (rule: any, val: string, callback: any) => {
  if (val) {
    if (/^(\d+|\d+\.\d{0,6})$/.test(val) || /^((\-?)\d+|(\-?)\d+\.\d{0,6})$/.test(val)) {
      callback()
    } else {
      callback(new Error(t('operate.vjnzvm')))
    }
  } else {
    callback()
  }
}
const selectData = (value: string) => {
  editForm.value.cosId = value
}
const handleSubmit = () => {
  formRef.value?.validate().then(async () => {
    loading.value = true
    const { arkCode, cosId, amount } = editForm.value
    const p = {
      arkCode,
      cosId,
      amount
    }
    try {
      if (editForm.value.id) {
        await updateBiTurnover({ ...p, id: editForm.value.id })
      } else {
        await addBiTurnover(p)
      }
      loading.value = false

      emit('success', editForm.value?.id ? 'edit' : 'add')
      DcMessage.success(editForm.value?.id ? t('operate.mmet2b') : t('operate.ywoekr'))
      toggle()
    } catch (error) {
      loading.value = false
    }
  })
}
defineExpose({
  toggle
})
</script>

<style lang="scss"></style>
